import { render } from "./Agenda.vue?vue&type=template&id=bc7cd178&scoped=true"
import script from "./Agenda.vue?vue&type=script&lang=js"
export * from "./Agenda.vue?vue&type=script&lang=js"

import "./Agenda.vue?vue&type=style&index=0&id=bc7cd178&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc7cd178"]])

export default __exports__